import PageHeading from "../headings/PageHeading";
import "./MedipayBaner.scss";
import MedipayLogo from "@/assets/images/png/partners/medipay-payments.png";

const MedipayBaner = () => {
  return (
    <section className="medipay">
      <div className="container">
        <div className="medipay__wrapper">
          <img src={MedipayLogo} alt="medipay logo" height="fit-content" />

          <div className="d-flex flex-column">
            <div className="d-flex align-items-center medipay__heading">
              <PageHeading variant="h2">Kup teraz, zapłać później</PageHeading>
            </div>

            <div className="d-flex align-items-center medipay__content">
              <p>
                Zrealizuj swoje potrzeby już dziś, a zapłać w dogodnym dla
                siebie terminie.<br></br> Szybko, wygodnie i bez stresu –
                Medipay daje Ci kontrolę nad budżetem.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MedipayBaner;
